import { grammaticalJoin } from '@/services/arrayUtils';

export default {
  methods: {
    getEmptyFields() {
      const emptyFields = [];
      this.requiredFields.forEach((field) => {
        const reportField = this.reportsFilter[field];
        if (!reportField || !reportField.length) {
          emptyFields.push(field);
        }
      });
      return emptyFields;
    },
    generateReport(resolve) {
      const emptyRequiredFields = this.getEmptyFields();
      if (!emptyRequiredFields.length) {
        return resolve();
      }
      return this.$pushAlert({
        code: 'MA001',
        messageParams: {
          NomeDoCampo: grammaticalJoin(emptyRequiredFields
            .map(field => this.getFieldLabel(field))),
        },
      });
    },
  },
};
